const STORAGE_KEY = 'suarte:quizAnswers';

const isBrowser = typeof window !== 'undefined';

const safeReadStore = () => {
  if (!isBrowser) return {};
  try {
    const raw = window.sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const parsed = JSON.parse(raw);
    return parsed && typeof parsed === 'object' ? parsed : {};
  } catch {
    return {};
  }
};

const safeWriteStore = (store) => {
  if (!isBrowser) return;
  try {
    window.sessionStorage.setItem(STORAGE_KEY, JSON.stringify(store));
  } catch {
    /* ignore quota errors */
  }
};

export const persistQuizAnswer = (postId, quizId, answerIndex) => {
  if (!postId || !quizId || answerIndex === undefined || answerIndex === null) {
    return;
  }
  const store = safeReadStore();
  const postKey = String(postId);
  const quizKey = String(quizId);
  const postEntry = store[postKey] || {};

  postEntry[quizKey] = {
    answerIndex,
    savedAt: Date.now(),
  };

  store[postKey] = postEntry;
  safeWriteStore(store);
};

export const getPersistedQuizAnswer = (postId, quizId) => {
  if (!postId || !quizId) return null;
  const store = safeReadStore();
  const postEntry = store[String(postId)];
  if (!postEntry) return null;
  return postEntry[String(quizId)] || null;
};

export const hydrateQuizzesWithPersistedAnswers = (postId, quizzes = []) =>
  quizzes.map(quiz => {
    if (quiz?.hasAnswered && quiz?.userAnswer !== undefined && quiz?.userAnswer !== null) {
      return quiz;
    }

    const persisted = getPersistedQuizAnswer(postId, quiz?.quizId);
    if (!persisted) return quiz;

    return {
      ...quiz,
      hasAnswered: true,
      userAnswer: persisted.answerIndex,
    };
  });
